import { FiChevronDown, FiDownload } from 'react-icons/fi';

export default function TransmissionsTable({ data = [], setSelectedTransmission }) {
  return (
    <div className="round-dg-wrapper">
      <table
        className="round-dg round-dg--light"
        style={{ minWidth: '700px' }}
      >
        <thead className="round-dg__header">
          <tr className="round-dg__row">
            <th className="round-dg__cell-header round-dg__cell-header--sm">Título</th>

            <th className="round-dg__cell-header round-dg__cell-header--sm min-w-72">Horas de transmissão</th>
            <th className="round-dg__cell-header round-dg__cell-header--sm">Número de transmissões</th>
            <th className="round-dg__cell-header round-dg__cell-header--sm w-20"></th>
          </tr>
        </thead>

        <tbody className="round-dg__body">
          {data?.map((item, i) => (
            <tr className="round-dg__row round-dg__row--clickable">
              <th className="round-dg__cell-header round-dg__cell-header--sm">
                <span className="mr-2 text-neutral">{i + 1}</span>
                <span className="text-sm font-semibold text-primary-dark">{item?.title}</span>
              </th>

              <td className="round-dg__cell round-dg__cell--sm">{item?.['transmission_hours']}</td>
              <td className="round-dg__cell round-dg__cell--sm">{item?.['transmissions_count']}</td>
              <td className="round-dg__cell round-dg__cell--sm">
                <span
                  onClick={() => {
                    setSelectedTransmission(item);
                  }}
                  className="card__icon-wrapper card__icon-wrapper--sm u-cursor-pointer ml-2"
                >
                  <FiChevronDown
                    style={{ transform: 'rotate(270deg)' }}
                    className="card__icon"
                  />
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
